import { CC_SPAWN } from '../world/areas/a01/CrashCoast';

export const REVIVE_HP = 40;
export const REVIVE_HUNGER = 35;
export const REVIVE_THIRST = 35;

export type DeathCause = 'wound' | 'thirst' | 'hunger' | 'fall';

export const DEATH_COPY: Record<DeathCause, string> = {
  wound: 'Something on Vesper Cay hit you hard enough to drop.',
  thirst: 'Your throat closed. You needed water.',
  hunger: 'You ran out of food and collapsed.',
  fall: 'You stepped off the island.',
};

export function deathCopy(cause: DeathCause | null | undefined): string {
  if (!cause) {
    return 'You lost consciousness on Vesper Cay.';
  }
  return DEATH_COPY[cause];
}

export function respawnAt(
  shelter: boolean,
  bed: { x: number; z: number } | null | undefined,
  centerY: number,
): { x: number; y: number; z: number } {
  if (shelter && bed) {
    return { x: bed.x, y: centerY + 0.02, z: bed.z };
  }
  return { x: CC_SPAWN.x, y: centerY + 0.02, z: CC_SPAWN.z };
}
